type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type VariablesState = {
  inflation?: number;
  yearsToProject?: number;
  baseDate?: string;
  investmentProperties?: {
    occupancyRate?: number;
    managementFeesRate?: number;
    ongoingCostsRate?: number;
  };
  [key: string]: any;
};

const defaultVariables: VariablesState = {
  inflation: Number(0.03),
  yearsToProject: Number(40),
  baseDate: new Date().toJSON().slice(0, 10),
  investmentProperties: {
    occupancyRate: Number(0.92), // 48 weeks avg. per annum
    managementFeesRate: Number(0.077),
    ongoingCostsRate: Number(0.015), // Rates, Insurance, Maintenance, etc.
  },
};

const initialState = defaultVariables;

const variablesReducer = (
  state: VariablesState = initialState,
  action: ReducerAction
): VariablesState => {
  switch (action.type) {
    case 'VARIABLES_UPDATE': {
      const { variables } = action;
      return {
        ...state,
        ...variables,
      };
    }
    default:
      return state;
  }
};
export default variablesReducer;
